import { memo } from 'react';
import { Box, Button, Image, Text } from '@bonanza-social/moonlight';
import { BottomSheetExtendedProps } from '@bonanza-social/navigation';
import { useNavigation } from '@bonanza-social/navigation';
import { StackNavigationProp } from '@bonanza-social/navigation';
import { Trans } from '@bonanza-social/i18n';

function PlayWithCoinsInfo({ close }: BottomSheetExtendedProps) {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handleBonanzaShopPress = () => {
    navigation.navigate('Shop');
  };

  return (
    <Box alignItems="center" gap="space-600">
      <Text
        variant="h5"
        color="darkSurfacePrimary"
        locNS="games"
        locKey="playWithCoinsInfoTitle"
        textAlign="center"
      />
      <Image name="common.BonanzaCoinStack" width={200} height={155} />
      <Text
        variant="body-m"
        color="darkSurfacePrimary"
        locNS="games"
        locKey="playWithCoinsInfoMessage"
        textAlign="center"
      />
      <Text
        variant="body-m"
        color="darkSurfacePrimary"
        locNS="games"
        locKey="playWithCoinsInfoMessageUseCoins"
        textAlign="center"
      >
        <Trans
          ns="games"
          i18nKey="playWithCoinsInfoMessageUseCoins"
          textAlign="center"
          components={{
            bonanzaShop: (
              <Text
                variant="link-medium"
                gradient="darkSurfaceAccent"
                onPress={handleBonanzaShopPress}
              />
            ),
          }}
        />
      </Text>
      <Button
        width="100%"
        variant="primary"
        locNS="games"
        locKey="playWithCoinsInfoCta"
        onPress={close}
      />
    </Box>
  );
}

export default memo(PlayWithCoinsInfo);
